var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
let SubjectStatusSelect = class SubjectStatusSelect extends Vue {
    // @Prop({ default: 'busy' })
    // protected default!: string;
    // protected selectedStatus: string | null = null;
    get statuses() {
        const statuses = ['highlighted', 'busy', 'old', 'closed', 'finished', 'inactive'];
        const items = [];
        statuses.forEach((status, index) => {
            items.push({ value: status, text: this.subjectStatusLabel(status) });
        });
        return items;
    }
    subjectStatusLabel(status) {
        if (!status) {
            return this.$tc(`idp.status.inactive`, 2);
        }
        const label = this.$store.state.labels.find((label) => {
            return label.key === status;
        });
        if (!label || label.value === label.key) {
            return this.$tc(`idp.status.${status}`, 2);
        }
        else {
            return label.value;
        }
    }
};
SubjectStatusSelect = __decorate([
    Component({
    //
    })
], SubjectStatusSelect);
export default SubjectStatusSelect;
